// extracted by mini-css-extract-plugin
module.exports = {"color-black":"#000000","colorBlack":"#000000","overlayContainer":"fPn00","title":"_1AYl4 _1R_Wx"};